import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextField,
  SelectInput,
  required,
} from "react-admin";
import { PUSH_NOTIFICATION_SERVICES_STATUSES } from "@local/constants/index.js";
import { CustomToolbar, Title } from "../../shared/components/index.js";

const editPushNotificationService = () => (
  <Edit
    redirect="list"
    title={<Title source="name" />}
    mutationMode="pessimistic"
  >
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextField source="name" />
      <SelectInput
        sx={{
          width: "20%",
          "@media (max-width:900px)": {
            width: "100%",
          },
        }}
        source="status"
        validate={[required()]}
        choices={Object.keys(PUSH_NOTIFICATION_SERVICES_STATUSES).map(
          (status) => ({
            id: status,
            name: `resources.EmailService.source.status.${status}`,
          })
        )}
      />
    </SimpleForm>
  </Edit>
);

export default editPushNotificationService;
